import type { ApiSuccess, Me, OtpStartResult } from '@capsico/contracts';
import { api } from './client';
import { turnstileHeaders } from './turnstile';

export async function fetchMe(): Promise<Me> {
  const res = await api.get<ApiSuccess<Me>>('/v1/auth/me');
  return res.data.data;
}

/** W25: `turnstileToken` is sent as x-turnstile-token in the browser build (none in the native app). */
export async function startCustomerSignIn(
  phone: string,
  turnstileToken?: string | null,
): Promise<OtpStartResult> {
  const res = await api.post<ApiSuccess<OtpStartResult>>(
    '/v1/auth/customer/otp/start',
    { phone },
    { headers: turnstileHeaders(turnstileToken) },
  );
  return res.data.data;
}

export async function verifyCustomerSignIn(phone: string, code: string): Promise<Me> {
  const res = await api.post<ApiSuccess<{ me: Me }>>('/v1/auth/customer/otp/verify', {
    phone,
    code,
  });
  return res.data.data.me;
}

export async function signOut(): Promise<void> {
  await api.post('/v1/auth/sign-out');
}
